// extracted by mini-css-extract-plugin
export default {"transcriptBadges":"transcriptBadges__VepResultsTranscript__l18qA","transcriptBadge":"transcriptBadge__VepResultsTranscript__l18qA"};